import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 515px;

  > div {
    margin-top: 25px;
  }

  @media (max-width: 1024px) {
    margin-left: 15%;
  }

  @media (max-width: 1500px) {
    max-width: 40%;
  }

  @media (max-width: 960px) {
    max-width: 100%;
    margin-left: 0;

    > div {
      margin: 25px 25px 0 25px;
    }
  }
`;

export const CheckboxContainer = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: 0% 0% no-repeat padding-box rgba(76, 56, 119, 0.2);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);

  @media (max-width: 960px) {
    margin: 0 1.5rem;
  }
`;

export const CheckboxContainerTitle = styled.h4`
  color: #ffffff;
  font-weight: 300;
  border-bottom: 1px solid rgba(140, 134, 156, 0.2);
  padding-bottom: 1.5rem;
`;

export const Error = styled.span`
  font-size: .8rem;
  font-weight: 500;
  color: #6c677a;
  text-align: left;
  color: #FF1343;
  margin-top: .5rem;
`;